<p-editor
  #editor
  [ngModel]="value"
  (ngModelChange)="onValueChange($event)"
  [placeholder]="placeholder"
  [style]="{ width: '100%', height: height }"
>
  <ng-template pTemplate="header">
    <span class="ql-formats">
      <button type="button" class="ql-bold"></button>
      <button type="button" class="ql-italic"></button>
      <button type="button" class="ql-underline"></button>
      <button type="button" class="ql-list" value="bullet"></button>
    </span>
    <!-- Clear icon button on right -->
    <div class="ql-toolbar-right">
      <button [pTooltip]="'Clear Text'" type="button" class="ql-clear" (click)="clearEditor()">✖</button>
    </div>
  </ng-template>
</p-editor>


